import { Controller } from "@hotwired/stimulus"

// ProvaVersioniModuli di components/verifica/ProvaVersioniModuli.js (passo 5 della scheda di verifica): lo stato che React
// teneva nel componente.
// - Chiusa all'inizio, nessuna richiesta. Aperta, il frame «prova-versioni-copie» carica le copie demo (solo
//   demo: true, VerificaController#prova_versioni_copie); ogni apertura le ricarica, «Riprova a caricare i progetti demo»
//   anche. L'errore delle copie non diventa un elenco vuoto.
// - Scelta la copia (e la fase) il frame «prova-versioni-moduli» prende il src di VerificaController#prova_versioni_moduli
//   (?project_id=&fase=): un src nuovo scarta la risposta tardiva della copia precedente; senza copia o chiusa non ha src.
//   La risposta porta le versioni dei moduli con la scelta salvata nella sola copia demo; dopo una scelta riuscita
//   (turbo:before-fetch-response del form della scheda: la scheda è il form e lo stream la sostituisce, un
//   turbo:submit-end non arriverebbe più a nessuno) il frame si rilegge (onSaved: carica). «Riprova la lettura della
//   prova» lo rilegge.
export default class extends Controller {
  static targets = ["apri", "pannello", "copia", "fase", "frameCopie", "frameProva", "caricamento", "errore", "erroreTesto", "nessuna", "attesa"]
  static values = { copieUrl: String, provaUrl: String }

  connect() {
    this.aperto = false
    this.copie = null
    this.errore = ""
  }

  apri() {
    this.aperto = !this.aperto
    this.apriTarget.textContent = this.aperto ? "Chiudi prova versioni" : "Prova versioni su progetto demo"
    this.pannelloTarget.hidden = !this.aperto
    if (this.aperto) this.carica()
    this.aggiorna()
  }

  carica() {
    this.copie = null
    this.errore = ""
    const frame = this.frameCopieTarget
    if (frame.getAttribute("src")) frame.reload()
    else frame.src = this.copieUrlValue
    this.mostra()
  }

  ricarica() {
    this.carica()
  }

  // turbo:frame-load: le copie, la prova o il dettaglio dell'errore
  caricate(event) {
    if (event.target === this.frameProvaTarget) { this.attesaTarget.hidden = true; this.frameProvaTarget.hidden = false; return }
    if (event.target !== this.frameCopieTarget || !this.aperto) return
    const dati = this.frameCopieTarget.querySelector("[data-copie]")
    if (!dati) { this.nonCaricate(); return }
    if (dati.dataset.errore !== undefined) { this.errore = dati.dataset.errore || "Progetti demo non caricati."; this.mostra(); return }
    this.copie = JSON.parse(dati.dataset.copie)
    this.scriviCopie()
    this.mostra()
  }

  mancanti(event) {
    if (event.target === this.frameProvaTarget) { event.preventDefault(); this.erroreProva(); return }
    if (event.target !== this.frameCopieTarget) return
    event.preventDefault()
    this.nonCaricate()
  }

  nonCaricate(event) {
    if (event && this.frameProvaTarget.contains(event.target)) { this.erroreProva(); return }
    if (event && !this.frameCopieTarget.contains(event.target) && event.target !== this.frameCopieTarget) return
    if (!this.aperto) return
    this.errore = "Progetti demo non caricati."
    this.mostra()
  }

  scriviCopie() {
    const select = this.copiaTarget
    const scelta = select.value
    select.querySelectorAll("option:not([value=''])").forEach((o) => o.remove())
    this.copie.forEach((p) => {
      const o = document.createElement("option")
      o.value = p.id
      o.textContent = `${p.name}${p.created_at ? ` · copia del ${new Date(p.created_at).toLocaleString("it-IT")}` : ""}`
      select.append(o)
    })
    select.value = this.copie.some((p) => p.id === scelta) ? scelta : ""
    if (select.value !== scelta) this.aggiorna()
  }

  mostra() {
    this.caricamentoTarget.hidden = !(this.copie === null && !this.errore)
    this.nessunaTarget.hidden = !(this.copie && this.copie.length === 0)
    this.erroreTarget.hidden = !this.errore
    this.erroreTestoTarget.textContent = this.errore
  }

  cambio() {
    this.aggiorna()
  }

  // useEffect su [aperto, projectId, fase]: la prova della copia scelta, o nulla
  aggiorna() {
    const frame = this.frameProvaTarget
    const progetto = this.copiaTarget.value
    frame.innerHTML = ""
    if (!this.aperto || !progetto) {
      frame.removeAttribute("src")
      frame.hidden = true
      this.attesaTarget.hidden = true
      return
    }
    const url = new URL(this.provaUrlValue, window.location.origin)
    url.searchParams.set("project_id", progetto)
    url.searchParams.set("fase", this.faseTarget.value)
    frame.hidden = true
    this.attesaTarget.hidden = false
    frame.src = url.pathname + url.search
  }

  // onSaved: la scelta è salvata, la prova si rilegge
  salvata(event) {
    const form = event.target
    if (!(form instanceof HTMLFormElement) || !this.frameProvaTarget.contains(form)) return
    if (event.detail?.fetchResponse?.succeeded) this.rileggi()
  }

  // «Riprova la lettura della prova»
  rileggi() {
    this.attesaTarget.hidden = false
    this.frameProvaTarget.hidden = true
    this.frameProvaTarget.reload()
  }

  erroreProva() {
    this.attesaTarget.hidden = true
    const frame = this.frameProvaTarget
    frame.hidden = false
    frame.innerHTML = ""
    const avviso = document.createElement("div")
    avviso.setAttribute("role", "alert")
    avviso.append("Prova non caricata. Riprova. ")
    const bottone = document.createElement("button")
    bottone.type = "button"
    bottone.textContent = "Riprova la lettura della prova"
    bottone.dataset.action = "prova-versioni-moduli#rileggi"
    avviso.append(bottone)
    frame.append(avviso)
  }
}
